import { render } from "./TextField.vue?vue&type=template&id=eb91132c"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"
script.render = render

export default script